<div class="flx-modal" role="dialog" aria-modal="true">
    <!-- Header -->
    <div class="flx-modal__header">
        <div class="with-back">
            <button class="back-btn" *ngIf="locationMode == 'createWithSearch'" (click)="goBack()">
                <i class="fa-regular fa-arrow-left"></i>
            </button>
            <h2>{{ title }}</h2>
        </div>
        <button class="icon-btn" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <!-- Body: FOR CHOOSING LOCATION -->
    <div class="flx-modal__body" *ngIf="locationMode === 'select'">
        <div class="addr-list">
            <button type="button" class="addr-card" *ngFor="let location of locationData"
                (click)="selectLocation(location)">
                <span class="addr-main">
                    <span class="addr-title">
                        <span class="icon"><img class="custella-mini-icon  menuIcon" [src]="location.icon" /></span>
                           
                        <span class="title"> {{location.title}}</span>
                        <div class="spacer"></div>
                    </span>
                    <span class="addr-sub">{{location.installationAddress}}</span>
                </span>
            </button>
        </div>
    </div>
    <div class="flx-modal__footer-between" *ngIf="locationMode === 'select'">
        <div class="apply">
            <p-button styleClass="dark-alt" label="{{translate?.general.buttons.add.singular}} {{translate?.general.locationDetails.fields.address.singular}}" icon="fa-regular fa-plus" (click)="goCreate()"></p-button>
        </div>
        <div class="triggers">
            <button class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
        </div>
    </div>

    <!-- Body: FOR ADDING LOCATION -->
    <form [formGroup]="form" *ngIf="locationMode == 'create' || locationMode == 'createWithSearch'">
        <div class="flx-modal__body lean gap-10">

            <!-- Search -->
            <div class="status-field">
                <label class="field-label">{{translate?.general.buttons.search.singular}}</label>
                <div class="field-row field-row--single gap-no">
                    <div class="flex-align-center gap-2">
                        <input type="text" pInputText autocomplete="off"
                            (keyup)="getPlaceApiCall($event)"
                            formControlName="title"
                            [placeholder]="translate?.general.messages.searchAddress"
                            autocorrect="off" autocapitalize="off" spellcheck="off"
                            #addressSearch
                            [(ngModel)]="searchInstallation"
                            id="input_JobOrdersAddressField" />
                        <!-- <button class="custella-btn-white w-150px">
                            <i class="fa-regular fa-location-dot me-2"></i>Pin Location
                        </button> -->
                    </div>
                    <div class="p-error text-10" *ngIf="form.controls['title'].touched && form.controls['title'].invalid">
                        <span *ngIf="form.controls['title']?.errors?.required"
                            id="label_JobAdditionalFaultReqField">{{translate?.general.validationFE.requiredField}}</span>
                    </div>
                </div>
            </div>

            <!-- ═══════════════════════════════════════════════════════════════════
                 Google Map
                 Replaced: commented-out <p-gmap #gmap (onOverlayDragEnd) (onMapClick)
                                                 [overlays] [options] [style]>

                 With:     <google-map #googleMap [options] [center] [zoom]
                                       width height [style] (mapClick)>
                             <map-marker *ngFor [position] [options] (mapDragend)>

                 Why the map wasn't showing before:
                   The entire <p-gmap> block was commented out in the HTML.
                   It is now replaced and uncommented with <google-map>.

                 Key changes vs p-gmap:
                   - (onOverlayDragEnd) on p-gmap → (mapDragend) on <map-marker>
                   - (onMapClick) on p-gmap → (mapClick) on <google-map>
                   - [overlays] array → <map-marker *ngFor [position] [options]>
                   - [options] map object → split into [options] [center] [zoom]
                   - (this.gmap as any).map.panTo / getMap().setZoom removed —
                     now just set mapCenter and mapZoom properties directly
            ════════════════════════════════════════════════════════════════════ -->
            <div class="status-field">
                <p-accordion (onOpen)="toggle($event)" (onClose)="toggle($event)">
                    <p-accordionTab [transitionOptions]="'0ms'" [(selected)]="activeState">
                        <p-header>
                            <span #header id="btn_JobShowMap1">
                                {{translate?.general.buttons.showMap.singular}}
                            </span>
                        </p-header>

                        <google-map
                            #googleMap
                            [options]="mapOptions"
                            [center]="mapCenter"
                            [zoom]="mapZoom"
                            width="calc(100% - 3px)"
                            height="320px"
                            [style]="{'border': '1px solid #e2e2e2',}"
                            (mapClick)="mapClicked($event, 'home')">

                            <map-marker
                                *ngFor="let m of mapMarkers"
                                [position]="m.position"
                                [options]="m.options"
                                (mapDragend)="markerDragEnd($event, 'home')">
                            </map-marker>

                        </google-map>

                    </p-accordionTab>
                </p-accordion>
            </div>

            <!-- Street -->
            <div class="status-field">
                <label class="field-label">{{translate?.general.locationDetails.fields.street.singular}}</label>
                <div class="field-row field-row--single gap-no">
                    <input type="text" formControlName="street" pInputText autocomplete="off"
                        [(ngModel)]="data.installationStreet" />
                    <div class="p-error text-10" *ngIf="form.controls['title'].touched && form.controls['title'].invalid">
                        <span *ngIf="form.controls['title']?.errors?.required"
                            id="label_JobAdditionalFaultReqField">{{translate?.general.validationFE.requiredField}}</span>
                    </div>
                </div>
            </div>

            <!-- City & State -->
            <div class="field-wrapper">
                <div class="status-field">
                    <label class="field-label">{{translate?.general.locationDetails.fields.city.singular}}</label>
                    <div class="field-row field-row--auto">
                        <input type="text" formControlName="city" pInputText autocomplete="off"
                            [(ngModel)]="data.installationCity" />
                    </div>
                </div>
                <div class="status-field">
                    <label class="field-label">{{translate?.general.locationDetails.fields.state.singular}}</label>
                    <div class="field-row field-row--auto">
                        <input type="text" formControlName="state" pInputText autocomplete="off"
                            [(ngModel)]="data.installationState" />
                    </div>
                </div>
            </div>

            <!-- Postcode & Country -->
            <div class="field-wrapper">
                <div class="status-field">
                    <label class="field-label">{{translate?.general.locationDetails.fields.postcode.singular}}</label>
                    <div class="field-row field-row--auto">
                        <input type="text" formControlName="postcode" pInputText autocomplete="off"
                            [(ngModel)]="data.installationPostalCode" />
                    </div>
                </div>
                <div class="status-field">
                    <label class="field-label">{{translate?.general.locationDetails.fields.country.singular}}</label>
                    <div class="field-row field-row--auto">
                        <p-dropdown *ngIf="translate" formControlName="country"
                            [options]="countries" filterBy="name"
                            optionLabel="name" optionValue="name"
                            [showClear]="true"
                            [placeholder]="translate?.general.messages.none"
                            [(ngModel)]="data.installationCountry"
                            name="installationCountry"
                            id="picklist_JobCountryField">
                        </p-dropdown>
                    </div>
                </div>
            </div>

            <!-- Latitude -->
            <div class="status-field">
                <label class="field-label">{{translate?.general.locationDetails.fields.latitude.singular}}</label>
                <div class="field-row field-row--auto">
                    <input type="text" [(ngModel)]="data.installationLatitude"
                        [ngModelOptions]="{standalone: true}" pInputText autocomplete="off" />
                </div>
            </div>

            <!-- Longitude -->
            <div class="status-field">
                <label class="field-label">{{translate?.general.locationDetails.fields.longitude.singular}}</label>
                <div class="field-row field-row--auto">
                    <input type="text" [(ngModel)]="data.installationLongitude"
                        [ngModelOptions]="{standalone: true}" pInputText autocomplete="off" />
                </div>
            </div>
        </div>

        <!-- Footer without Add Address -->
        <div class="flx-modal__footer" *ngIf="locationMode == 'create' || locationMode == 'createWithSearch'">
            <button class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
            <p-button [label]="translate?.general.buttons.update.singular" type="button" styleClass="h-32" (onClick)="updateLocation()"></p-button>
        </div>
    </form>
</div>